import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class NmbrPayrollInfoState {
  emojiReady;

  paySchedules = [];
  isLoading = false;
  errors = false;

  constructor() {
    makeAutoObservable(this, {
      emojiReady: false
    });
  }

  receiveProps({isLoading, paySchedules, errors, emojiReady}) {
    this.paySchedules = paySchedules;
    this.isLoading = isLoading;
    this.errors = errors;
    this.emojiReady = emojiReady;
  }

  get hasMultipleBusinessEntities() {
    return _.uniqBy(this.paySchedules, 'businessEntityName').length > 1;
  }

  get paySchedulesGroupedByEntity() {
    return _.groupBy(this.paySchedules, 'businessEntityName');
  }
}

export default NmbrPayrollInfoState;
